// Max number of values on a "in" query in Firestore
export const FIREBASE_MAX_IN_BATCH_SIZE = 30;

export const CONSTANTS = {
  OFFER: {
    CONTEST: {
      REMAINING_QTY: 9999,
    },
  },
};

export const DEFAULT_OFFER_PRIORITY = 30;

export const DEFAULT_TIMEZONE = {
  utcValue: 'UTC-3',
  value: 'US/Central',
  label: 'Central Time',
};

export const TIMEZONES_VALUES = [
  {
    utcValue: 'UTC-1',
    value: 'US/Pacific',
    label: 'Pacific Time',
  },
  {
    utcValue: 'UTC-2',
    value: 'US/Mountain',
    label: 'Mountain Time',
  },
  {
    utcValue: 'UTC-3',
    value: 'US/Central',
    label: 'Central Time',
  },
  {
    utcValue: 'UTC-4',
    value: 'US/Eastern',
    label: 'Eastern Time',
  },
  {
    utcValue: 'UTC-9',
    value: 'US/Alaska',
    label: 'Alaska Time',
  },
  {
    utcValue: 'UTC-10',
    value: 'US/Hawaii',
    label: 'Hawaii Time',
  },
];

export enum APPS {
  CONNECT_OFFICE,
  CONNECT_BRAND,
  TEAM_MANAGER,
}

export const SELL_SHEET_OFFER_NAME = 'Sell Sheet';

export const OFFER_TYPES_PRETTY = [
  {
    value: 'video',
    display: 'Video',
  },
  {
    value: 'survey',
    display: 'Survey',
  },
  {
    value: 'quiz',
    display: 'Quiz',
  },
  {
    value: 'employeeVerification',
    display: 'Employee Verification',
  },
  // TODO: Uncomment this once makio is running up
  // {
  //   value: 'dollarContest',
  //   display: 'Dollar Contest',
  // },
  // {
  //   value: 'skuContest',
  //   display: 'Per Unit contest',
  // },
  // {
  //   value: 'teamContest',
  //   display: 'Team contest',
  // },
  {
    value: 'carousel',
    display: 'Carousel',
  },
  // {
  //   value: 'video',
  //   display: 'Video',
  // },
  {
    value: 'sellSheet',
    display: SELL_SHEET_OFFER_NAME,
  },
];

export const OFFER_STATUS_PRETTY = [
  {
    value: 'draft',
    display: 'Draft',
  },
  {
    value: 'publish',
    display: 'Publish',
  },
  {
    value: 'active',
    display: 'Active',
  },
  {
    value: 'paused',
    display: 'Paused',
  },
  {
    value: 'archived',
    display: 'Archived',
  },
] as const;

export interface StateInterface {
  value: string;
  display: string;
};

export const STATES: StateInterface[] = [
  { value: 'AL', display: 'Alabama' },
  { value: 'AK', display: 'Alaska' },
  { value: 'AS', display: 'American Samoa' },
  { value: 'AZ', display: 'Arizona' },
  { value: 'AR', display: 'Arkansas' },
  { value: 'CA', display: 'California' },
  { value: 'CO', display: 'Colorado' },
  { value: 'CT', display: 'Connecticut' },
  { value: 'DE', display: 'Delaware' },
  { value: 'DC', display: 'District Of Columbia' },
  { value: 'FM', display: 'Federated States Of Micronesia' },
  { value: 'FL', display: 'Florida' },
  { value: 'GA', display: 'Georgia' },
  { value: 'GU', display: 'Guam' },
  { value: 'HI', display: 'Hawaii' },
  { value: 'ID', display: 'Idaho' },
  { value: 'IL', display: 'Illinois' },
  { value: 'IN', display: 'Indiana' },
  { value: 'IA', display: 'Iowa' },
  { value: 'KS', display: 'Kansas' },
  { value: 'KY', display: 'Kentucky' },
  { value: 'LA', display: 'Louisiana' },
  { value: 'ME', display: 'Maine' },
  { value: 'MH', display: 'Marshall Islands' },
  { value: 'MD', display: 'Maryland' },
  { value: 'MA', display: 'Massachusetts' },
  { value: 'MI', display: 'Michigan' },
  { value: 'MN', display: 'Minnesota' },
  { value: 'MS', display: 'Mississippi' },
  { value: 'MO', display: 'Missouri' },
  { value: 'MT', display: 'Montana' },
  { value: 'NE', display: 'Nebraska' },
  { value: 'NV', display: 'Nevada' },
  { value: 'NH', display: 'New Hampshire' },
  { value: 'NJ', display: 'New Jersey' },
  { value: 'NM', display: 'New Mexico' },
  { value: 'NY', display: 'New York' },
  { value: 'NC', display: 'North Carolina' },
  { value: 'ND', display: 'North Dakota' },
  { value: 'MP', display: 'Northern Mariana Islands' },
  { value: 'OH', display: 'Ohio' },
  { value: 'OK', display: 'Oklahoma' },
  { value: 'OR', display: 'Oregon' },
  { value: 'PW', display: 'Palau' },
  { value: 'PA', display: 'Pennsylvania' },
  { value: 'PR', display: 'Puerto Rico' },
  { value: 'RI', display: 'Rhode Island' },
  { value: 'SC', display: 'South Carolina' },
  { value: 'SD', display: 'South Dakota' },
  { value: 'TN', display: 'Tennessee' },
  { value: 'TX', display: 'Texas' },
  { value: 'UT', display: 'Utah' },
  { value: 'VT', display: 'Vermont' },
  { value: 'VI', display: 'Virgin Islands' },
  { value: 'VA', display: 'Virginia' },
  { value: 'WA', display: 'Washington' },
  { value: 'WV', display: 'West Virginia' },
  { value: 'WI', display: 'Wisconsin' },
  { value: 'WY', display: 'Wyoming' },
  { value: 'NW', display: 'Nationwide' },
];

export const Platform = 'Cellar'
export const PlatformAndDomain = 'Cellar'
export const PlatformLink = 'cellarco.ai'

export interface Timezone {
  value: string;
  label: string;
  offset: string;
  dstOffset: string;
}

export const TIMEZONES: Timezone[] = [
  // {
  //   "value": "Asia/Kolkata",
  //   "label": "Asia/Kolkata (IST – no DST)",
  //   "offset": "+05:30",
  //   "dstOffset": "+05:30"
  // },
  {
    "value": "Africa/Abidjan",
    "label": "Africa/Abidjan (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Accra",
    "label": "Africa/Accra (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Addis_Ababa",
    "label": "Africa/Addis_Ababa (EAT – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Africa/Algiers",
    "label": "Africa/Algiers (CET – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Asmara",
    "label": "Africa/Asmara (EAT – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Africa/Asmera",
    "label": "Africa/Asmera (EAT – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Africa/Bamako",
    "label": "Africa/Bamako (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Bangui",
    "label": "Africa/Bangui (WAT – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Banjul",
    "label": "Africa/Banjul (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Bissau",
    "label": "Africa/Bissau (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Blantyre",
    "label": "Africa/Blantyre (CAT – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Brazzaville",
    "label": "Africa/Brazzaville (WAT – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Bujumbura",
    "label": "Africa/Bujumbura (CAT – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Cairo",
    "label": "Africa/Cairo (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Africa/Casablanca",
    "label": "Africa/Casablanca (+01 – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Ceuta",
    "label": "Africa/Ceuta (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Conakry",
    "label": "Africa/Conakry (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Dakar",
    "label": "Africa/Dakar (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Dar_es_Salaam",
    "label": "Africa/Dar_es_Salaam (EAT – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Africa/Djibouti",
    "label": "Africa/Djibouti (EAT – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Africa/Douala",
    "label": "Africa/Douala (WAT – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/El_Aaiun",
    "label": "Africa/El_Aaiun (+01 – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Freetown",
    "label": "Africa/Freetown (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Gaborone",
    "label": "Africa/Gaborone (CAT – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Harare",
    "label": "Africa/Harare (CAT – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Johannesburg",
    "label": "Africa/Johannesburg (SAST – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Juba",
    "label": "Africa/Juba (CAT – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Kampala",
    "label": "Africa/Kampala (EAT – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Africa/Khartoum",
    "label": "Africa/Khartoum (CAT – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Kigali",
    "label": "Africa/Kigali (CAT – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Kinshasa",
    "label": "Africa/Kinshasa (WAT – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Lagos",
    "label": "Africa/Lagos (WAT – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Libreville",
    "label": "Africa/Libreville (WAT – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Lome",
    "label": "Africa/Lome (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Luanda",
    "label": "Africa/Luanda (WAT – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Lubumbashi",
    "label": "Africa/Lubumbashi (CAT – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Lusaka",
    "label": "Africa/Lusaka (CAT – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Malabo",
    "label": "Africa/Malabo (WAT – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Maputo",
    "label": "Africa/Maputo (CAT – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Maseru",
    "label": "Africa/Maseru (SAST – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Mbabane",
    "label": "Africa/Mbabane (SAST – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Mogadishu",
    "label": "Africa/Mogadishu (EAT – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Africa/Monrovia",
    "label": "Africa/Monrovia (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Nairobi",
    "label": "Africa/Nairobi (EAT – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Africa/Ndjamena",
    "label": "Africa/Ndjamena (WAT – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Niamey",
    "label": "Africa/Niamey (WAT – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Nouakchott",
    "label": "Africa/Nouakchott (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Ouagadougou",
    "label": "Africa/Ouagadougou (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Porto-Novo",
    "label": "Africa/Porto-Novo (WAT – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Sao_Tome",
    "label": "Africa/Sao_Tome (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Timbuktu",
    "label": "Africa/Timbuktu (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Africa/Tripoli",
    "label": "Africa/Tripoli (EET – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Africa/Tunis",
    "label": "Africa/Tunis (CET – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Africa/Windhoek",
    "label": "Africa/Windhoek (CAT – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "America/Adak",
    "label": "America/Adak (HST/HDT)",
    "offset": "-10:00",
    "dstOffset": "-09:00"
  },
  {
    "value": "America/Anchorage",
    "label": "America/Anchorage (AKST/AKDT)",
    "offset": "-09:00",
    "dstOffset": "-08:00"
  },
  {
    "value": "America/Anguilla",
    "label": "America/Anguilla (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Antigua",
    "label": "America/Antigua (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Araguaina",
    "label": "America/Araguaina (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/Buenos_Aires",
    "label": "America/Argentina/Buenos_Aires (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/Catamarca",
    "label": "America/Argentina/Catamarca (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/ComodRivadavia",
    "label": "America/Argentina/ComodRivadavia (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/Cordoba",
    "label": "America/Argentina/Cordoba (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/Jujuy",
    "label": "America/Argentina/Jujuy (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/La_Rioja",
    "label": "America/Argentina/La_Rioja (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/Mendoza",
    "label": "America/Argentina/Mendoza (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/Rio_Gallegos",
    "label": "America/Argentina/Rio_Gallegos (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/Salta",
    "label": "America/Argentina/Salta (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/San_Juan",
    "label": "America/Argentina/San_Juan (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/San_Luis",
    "label": "America/Argentina/San_Luis (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/Tucuman",
    "label": "America/Argentina/Tucuman (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Argentina/Ushuaia",
    "label": "America/Argentina/Ushuaia (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Aruba",
    "label": "America/Aruba (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Asuncion",
    "label": "America/Asuncion (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Atikokan",
    "label": "America/Atikokan (EST – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Atka",
    "label": "America/Atka (HST/HDT)",
    "offset": "-10:00",
    "dstOffset": "-09:00"
  },
  {
    "value": "America/Bahia",
    "label": "America/Bahia (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Bahia_Banderas",
    "label": "America/Bahia_Banderas (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Barbados",
    "label": "America/Barbados (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Belem",
    "label": "America/Belem (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Belize",
    "label": "America/Belize (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Blanc-Sablon",
    "label": "America/Blanc-Sablon (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Boa_Vista",
    "label": "America/Boa_Vista (-04 – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Bogota",
    "label": "America/Bogota (-05 – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Boise",
    "label": "America/Boise (MST/MDT)",
    "offset": "-07:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Buenos_Aires",
    "label": "America/Buenos_Aires (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Cambridge_Bay",
    "label": "America/Cambridge_Bay (MST/MDT)",
    "offset": "-07:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Campo_Grande",
    "label": "America/Campo_Grande (-04 – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Cancun",
    "label": "America/Cancun (EST – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Caracas",
    "label": "America/Caracas (-04 – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Catamarca",
    "label": "America/Catamarca (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Cayenne",
    "label": "America/Cayenne (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Cayman",
    "label": "America/Cayman (EST – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Chicago",
    "label": "America/Chicago (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Chihuahua",
    "label": "America/Chihuahua (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Ciudad_Juarez",
    "label": "America/Ciudad_Juarez (MST/MDT)",
    "offset": "-07:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Coral_Harbour",
    "label": "America/Coral_Harbour (EST – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Cordoba",
    "label": "America/Cordoba (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Costa_Rica",
    "label": "America/Costa_Rica (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Coyhaique",
    "label": "America/Coyhaique (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Creston",
    "label": "America/Creston (MST – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Cuiaba",
    "label": "America/Cuiaba (-04 – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Curacao",
    "label": "America/Curacao (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Danmarkshavn",
    "label": "America/Danmarkshavn (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "America/Dawson",
    "label": "America/Dawson (MST – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Dawson_Creek",
    "label": "America/Dawson_Creek (MST – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Denver",
    "label": "America/Denver (MST/MDT)",
    "offset": "-07:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Detroit",
    "label": "America/Detroit (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Dominica",
    "label": "America/Dominica (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Edmonton",
    "label": "America/Edmonton (MST/MDT)",
    "offset": "-07:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Eirunepe",
    "label": "America/Eirunepe (-05 – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/El_Salvador",
    "label": "America/El_Salvador (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Ensenada",
    "label": "America/Ensenada (PST/PDT)",
    "offset": "-08:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Fort_Nelson",
    "label": "America/Fort_Nelson (MST – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Fort_Wayne",
    "label": "America/Fort_Wayne (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Fortaleza",
    "label": "America/Fortaleza (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Glace_Bay",
    "label": "America/Glace_Bay (AST/ADT)",
    "offset": "-04:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Godthab",
    "label": "America/Godthab (-02/-01)",
    "offset": "-02:00",
    "dstOffset": "-01:00"
  },
  {
    "value": "America/Goose_Bay",
    "label": "America/Goose_Bay (AST/ADT)",
    "offset": "-04:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Grand_Turk",
    "label": "America/Grand_Turk (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Grenada",
    "label": "America/Grenada (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Guadeloupe",
    "label": "America/Guadeloupe (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Guatemala",
    "label": "America/Guatemala (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Guayaquil",
    "label": "America/Guayaquil (-05 – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Guyana",
    "label": "America/Guyana (-04 – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Halifax",
    "label": "America/Halifax (AST/ADT)",
    "offset": "-04:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Havana",
    "label": "America/Havana (CST/CDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Hermosillo",
    "label": "America/Hermosillo (MST – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Indiana/Indianapolis",
    "label": "America/Indiana/Indianapolis (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Indiana/Knox",
    "label": "America/Indiana/Knox (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Indiana/Marengo",
    "label": "America/Indiana/Marengo (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Indiana/Petersburg",
    "label": "America/Indiana/Petersburg (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Indiana/Tell_City",
    "label": "America/Indiana/Tell_City (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Indiana/Vevay",
    "label": "America/Indiana/Vevay (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Indiana/Vincennes",
    "label": "America/Indiana/Vincennes (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Indiana/Winamac",
    "label": "America/Indiana/Winamac (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Indianapolis",
    "label": "America/Indianapolis (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Inuvik",
    "label": "America/Inuvik (MST/MDT)",
    "offset": "-07:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Iqaluit",
    "label": "America/Iqaluit (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Jamaica",
    "label": "America/Jamaica (EST – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Jujuy",
    "label": "America/Jujuy (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Juneau",
    "label": "America/Juneau (AKST/AKDT)",
    "offset": "-09:00",
    "dstOffset": "-08:00"
  },
  {
    "value": "America/Kentucky/Louisville",
    "label": "America/Kentucky/Louisville (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Kentucky/Monticello",
    "label": "America/Kentucky/Monticello (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Knox_IN",
    "label": "America/Knox_IN (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Kralendijk",
    "label": "America/Kralendijk (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/La_Paz",
    "label": "America/La_Paz (-04 – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Lima",
    "label": "America/Lima (-05 – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Los_Angeles",
    "label": "America/Los_Angeles (PST/PDT)",
    "offset": "-08:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Louisville",
    "label": "America/Louisville (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Lower_Princes",
    "label": "America/Lower_Princes (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Maceio",
    "label": "America/Maceio (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Managua",
    "label": "America/Managua (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Manaus",
    "label": "America/Manaus (-04 – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Marigot",
    "label": "America/Marigot (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Martinique",
    "label": "America/Martinique (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Matamoros",
    "label": "America/Matamoros (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Mazatlan",
    "label": "America/Mazatlan (MST – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Mendoza",
    "label": "America/Mendoza (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Menominee",
    "label": "America/Menominee (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Merida",
    "label": "America/Merida (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Metlakatla",
    "label": "America/Metlakatla (AKST/AKDT)",
    "offset": "-09:00",
    "dstOffset": "-08:00"
  },
  {
    "value": "America/Mexico_City",
    "label": "America/Mexico_City (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Miquelon",
    "label": "America/Miquelon (-03/-02)",
    "offset": "-03:00",
    "dstOffset": "-02:00"
  },
  {
    "value": "America/Moncton",
    "label": "America/Moncton (AST/ADT)",
    "offset": "-04:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Monterrey",
    "label": "America/Monterrey (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Montevideo",
    "label": "America/Montevideo (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Montreal",
    "label": "America/Montreal (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Montserrat",
    "label": "America/Montserrat (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Nassau",
    "label": "America/Nassau (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/New_York",
    "label": "America/New_York (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Nipigon",
    "label": "America/Nipigon (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Nome",
    "label": "America/Nome (AKST/AKDT)",
    "offset": "-09:00",
    "dstOffset": "-08:00"
  },
  {
    "value": "America/Noronha",
    "label": "America/Noronha (-02 – no DST)",
    "offset": "-02:00",
    "dstOffset": "-02:00"
  },
  {
    "value": "America/North_Dakota/Beulah",
    "label": "America/North_Dakota/Beulah (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/North_Dakota/Center",
    "label": "America/North_Dakota/Center (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/North_Dakota/New_Salem",
    "label": "America/North_Dakota/New_Salem (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Nuuk",
    "label": "America/Nuuk (-02/-01)",
    "offset": "-02:00",
    "dstOffset": "-01:00"
  },
  {
    "value": "America/Ojinaga",
    "label": "America/Ojinaga (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Panama",
    "label": "America/Panama (EST – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Pangnirtung",
    "label": "America/Pangnirtung (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Paramaribo",
    "label": "America/Paramaribo (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Phoenix",
    "label": "America/Phoenix (MST – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Port-au-Prince",
    "label": "America/Port-au-Prince (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Port_of_Spain",
    "label": "America/Port_of_Spain (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Porto_Acre",
    "label": "America/Porto_Acre (-05 – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Porto_Velho",
    "label": "America/Porto_Velho (-04 – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Puerto_Rico",
    "label": "America/Puerto_Rico (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Punta_Arenas",
    "label": "America/Punta_Arenas (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Rainy_River",
    "label": "America/Rainy_River (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Rankin_Inlet",
    "label": "America/Rankin_Inlet (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Recife",
    "label": "America/Recife (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Regina",
    "label": "America/Regina (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Resolute",
    "label": "America/Resolute (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Rio_Branco",
    "label": "America/Rio_Branco (-05 – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Rosario",
    "label": "America/Rosario (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Santa_Isabel",
    "label": "America/Santa_Isabel (PST/PDT)",
    "offset": "-08:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Santarem",
    "label": "America/Santarem (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Santiago",
    "label": "America/Santiago (-03/-04)",
    "offset": "-03:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Santo_Domingo",
    "label": "America/Santo_Domingo (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Sao_Paulo",
    "label": "America/Sao_Paulo (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Scoresbysund",
    "label": "America/Scoresbysund (-02/-01)",
    "offset": "-02:00",
    "dstOffset": "-01:00"
  },
  {
    "value": "America/Shiprock",
    "label": "America/Shiprock (MST/MDT)",
    "offset": "-07:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Sitka",
    "label": "America/Sitka (AKST/AKDT)",
    "offset": "-09:00",
    "dstOffset": "-08:00"
  },
  {
    "value": "America/St_Barthelemy",
    "label": "America/St_Barthelemy (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/St_Johns",
    "label": "America/St_Johns (NST/NDT)",
    "offset": "-03:30",
    "dstOffset": "-02:30"
  },
  {
    "value": "America/St_Kitts",
    "label": "America/St_Kitts (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/St_Lucia",
    "label": "America/St_Lucia (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/St_Thomas",
    "label": "America/St_Thomas (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/St_Vincent",
    "label": "America/St_Vincent (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Swift_Current",
    "label": "America/Swift_Current (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Tegucigalpa",
    "label": "America/Tegucigalpa (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "America/Thule",
    "label": "America/Thule (AST/ADT)",
    "offset": "-04:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "America/Thunder_Bay",
    "label": "America/Thunder_Bay (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Tijuana",
    "label": "America/Tijuana (PST/PDT)",
    "offset": "-08:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Toronto",
    "label": "America/Toronto (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Tortola",
    "label": "America/Tortola (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Vancouver",
    "label": "America/Vancouver (PST/PDT)",
    "offset": "-08:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Virgin",
    "label": "America/Virgin (AST – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "America/Whitehorse",
    "label": "America/Whitehorse (MST – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "America/Winnipeg",
    "label": "America/Winnipeg (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "America/Yakutat",
    "label": "America/Yakutat (AKST/AKDT)",
    "offset": "-09:00",
    "dstOffset": "-08:00"
  },
  {
    "value": "America/Yellowknife",
    "label": "America/Yellowknife (MST/MDT)",
    "offset": "-07:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "Antarctica/Casey",
    "label": "Antarctica/Casey (+08 – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Antarctica/Davis",
    "label": "Antarctica/Davis (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Antarctica/DumontDUrville",
    "label": "Antarctica/DumontDUrville (+10 – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Antarctica/Macquarie",
    "label": "Antarctica/Macquarie (AEDT/AEST)",
    "offset": "+11:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Antarctica/Mawson",
    "label": "Antarctica/Mawson (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Antarctica/McMurdo",
    "label": "Antarctica/McMurdo (NZDT/NZST)",
    "offset": "+13:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Antarctica/Palmer",
    "label": "Antarctica/Palmer (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "Antarctica/Rothera",
    "label": "Antarctica/Rothera (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "Antarctica/South_Pole",
    "label": "Antarctica/South_Pole (NZDT/NZST)",
    "offset": "+13:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Antarctica/Syowa",
    "label": "Antarctica/Syowa (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Antarctica/Troll",
    "label": "Antarctica/Troll (+00/+02)",
    "offset": "+00:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Antarctica/Vostok",
    "label": "Antarctica/Vostok (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Arctic/Longyearbyen",
    "label": "Arctic/Longyearbyen (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Asia/Aden",
    "label": "Asia/Aden (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Almaty",
    "label": "Asia/Almaty (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Amman",
    "label": "Asia/Amman (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Anadyr",
    "label": "Asia/Anadyr (+12 – no DST)",
    "offset": "+12:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Asia/Aqtau",
    "label": "Asia/Aqtau (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Aqtobe",
    "label": "Asia/Aqtobe (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Ashgabat",
    "label": "Asia/Ashgabat (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Ashkhabad",
    "label": "Asia/Ashkhabad (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Atyrau",
    "label": "Asia/Atyrau (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Baghdad",
    "label": "Asia/Baghdad (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Bahrain",
    "label": "Asia/Bahrain (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Baku",
    "label": "Asia/Baku (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Asia/Bangkok",
    "label": "Asia/Bangkok (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Barnaul",
    "label": "Asia/Barnaul (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Beirut",
    "label": "Asia/Beirut (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Bishkek",
    "label": "Asia/Bishkek (+06 – no DST)",
    "offset": "+06:00",
    "dstOffset": "+06:00"
  },
  {
    "value": "Asia/Brunei",
    "label": "Asia/Brunei (+08 – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Calcutta",
    "label": "Asia/Calcutta (IST – no DST)",
    "offset": "+05:30",
    "dstOffset": "+05:30"
  },
  {
    "value": "Asia/Chita",
    "label": "Asia/Chita (+09 – no DST)",
    "offset": "+09:00",
    "dstOffset": "+09:00"
  },
  {
    "value": "Asia/Choibalsan",
    "label": "Asia/Choibalsan (+08 – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Chongqing",
    "label": "Asia/Chongqing (CST – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Chungking",
    "label": "Asia/Chungking (CST – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Colombo",
    "label": "Asia/Colombo (+0530 – no DST)",
    "offset": "+05:30",
    "dstOffset": "+05:30"
  },
  {
    "value": "Asia/Dacca",
    "label": "Asia/Dacca (+06 – no DST)",
    "offset": "+06:00",
    "dstOffset": "+06:00"
  },
  {
    "value": "Asia/Damascus",
    "label": "Asia/Damascus (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Dhaka",
    "label": "Asia/Dhaka (+06 – no DST)",
    "offset": "+06:00",
    "dstOffset": "+06:00"
  },
  {
    "value": "Asia/Dili",
    "label": "Asia/Dili (+09 – no DST)",
    "offset": "+09:00",
    "dstOffset": "+09:00"
  },
  {
    "value": "Asia/Dubai",
    "label": "Asia/Dubai (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Asia/Dushanbe",
    "label": "Asia/Dushanbe (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Famagusta",
    "label": "Asia/Famagusta (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Gaza",
    "label": "Asia/Gaza (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Harbin",
    "label": "Asia/Harbin (CST – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Hebron",
    "label": "Asia/Hebron (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Ho_Chi_Minh",
    "label": "Asia/Ho_Chi_Minh (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Hong_Kong",
    "label": "Asia/Hong_Kong (HKT – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Hovd",
    "label": "Asia/Hovd (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Irkutsk",
    "label": "Asia/Irkutsk (+08 – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Istanbul",
    "label": "Asia/Istanbul (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Jakarta",
    "label": "Asia/Jakarta (WIB – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Jayapura",
    "label": "Asia/Jayapura (WIT – no DST)",
    "offset": "+09:00",
    "dstOffset": "+09:00"
  },
  {
    "value": "Asia/Jerusalem",
    "label": "Asia/Jerusalem (IST/IDT)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Kabul",
    "label": "Asia/Kabul (+0430 – no DST)",
    "offset": "+04:30",
    "dstOffset": "+04:30"
  },
  {
    "value": "Asia/Kamchatka",
    "label": "Asia/Kamchatka (+12 – no DST)",
    "offset": "+12:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Asia/Karachi",
    "label": "Asia/Karachi (PKT – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Kashgar",
    "label": "Asia/Kashgar (+06 – no DST)",
    "offset": "+06:00",
    "dstOffset": "+06:00"
  },
  {
    "value": "Asia/Kathmandu",
    "label": "Asia/Kathmandu (+0545 – no DST)",
    "offset": "+05:45",
    "dstOffset": "+05:45"
  },
  {
    "value": "Asia/Katmandu",
    "label": "Asia/Katmandu (+0545 – no DST)",
    "offset": "+05:45",
    "dstOffset": "+05:45"
  },
  {
    "value": "Asia/Khandyga",
    "label": "Asia/Khandyga (+09 – no DST)",
    "offset": "+09:00",
    "dstOffset": "+09:00"
  },
  {
    "value": "Asia/Kolkata",
    "label": "Asia/Kolkata (IST – no DST)",
    "offset": "+05:30",
    "dstOffset": "+05:30"
  },
  {
    "value": "Asia/Krasnoyarsk",
    "label": "Asia/Krasnoyarsk (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Kuala_Lumpur",
    "label": "Asia/Kuala_Lumpur (+08 – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Kuching",
    "label": "Asia/Kuching (+08 – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Kuwait",
    "label": "Asia/Kuwait (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Macao",
    "label": "Asia/Macao (CST – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Macau",
    "label": "Asia/Macau (CST – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Magadan",
    "label": "Asia/Magadan (+11 – no DST)",
    "offset": "+11:00",
    "dstOffset": "+11:00"
  },
  {
    "value": "Asia/Makassar",
    "label": "Asia/Makassar (WITA – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Manila",
    "label": "Asia/Manila (PST – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Muscat",
    "label": "Asia/Muscat (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Asia/Nicosia",
    "label": "Asia/Nicosia (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Novokuznetsk",
    "label": "Asia/Novokuznetsk (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Novosibirsk",
    "label": "Asia/Novosibirsk (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Omsk",
    "label": "Asia/Omsk (+06 – no DST)",
    "offset": "+06:00",
    "dstOffset": "+06:00"
  },
  {
    "value": "Asia/Oral",
    "label": "Asia/Oral (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Phnom_Penh",
    "label": "Asia/Phnom_Penh (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Pontianak",
    "label": "Asia/Pontianak (WIB – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Pyongyang",
    "label": "Asia/Pyongyang (KST – no DST)",
    "offset": "+09:00",
    "dstOffset": "+09:00"
  },
  {
    "value": "Asia/Qatar",
    "label": "Asia/Qatar (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Qostanay",
    "label": "Asia/Qostanay (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Qyzylorda",
    "label": "Asia/Qyzylorda (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Rangoon",
    "label": "Asia/Rangoon (+0630 – no DST)",
    "offset": "+06:30",
    "dstOffset": "+06:30"
  },
  {
    "value": "Asia/Riyadh",
    "label": "Asia/Riyadh (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Saigon",
    "label": "Asia/Saigon (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Sakhalin",
    "label": "Asia/Sakhalin (+11 – no DST)",
    "offset": "+11:00",
    "dstOffset": "+11:00"
  },
  {
    "value": "Asia/Samarkand",
    "label": "Asia/Samarkand (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Seoul",
    "label": "Asia/Seoul (KST – no DST)",
    "offset": "+09:00",
    "dstOffset": "+09:00"
  },
  {
    "value": "Asia/Shanghai",
    "label": "Asia/Shanghai (CST – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Singapore",
    "label": "Asia/Singapore (+08 – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Srednekolymsk",
    "label": "Asia/Srednekolymsk (+11 – no DST)",
    "offset": "+11:00",
    "dstOffset": "+11:00"
  },
  {
    "value": "Asia/Taipei",
    "label": "Asia/Taipei (CST – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Tashkent",
    "label": "Asia/Tashkent (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Tbilisi",
    "label": "Asia/Tbilisi (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Asia/Tehran",
    "label": "Asia/Tehran (+0330 – no DST)",
    "offset": "+03:30",
    "dstOffset": "+03:30"
  },
  {
    "value": "Asia/Tel_Aviv",
    "label": "Asia/Tel_Aviv (IST/IDT)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Asia/Thimbu",
    "label": "Asia/Thimbu (+06 – no DST)",
    "offset": "+06:00",
    "dstOffset": "+06:00"
  },
  {
    "value": "Asia/Thimphu",
    "label": "Asia/Thimphu (+06 – no DST)",
    "offset": "+06:00",
    "dstOffset": "+06:00"
  },
  {
    "value": "Asia/Tokyo",
    "label": "Asia/Tokyo (JST – no DST)",
    "offset": "+09:00",
    "dstOffset": "+09:00"
  },
  {
    "value": "Asia/Tomsk",
    "label": "Asia/Tomsk (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Ujung_Pandang",
    "label": "Asia/Ujung_Pandang (WITA – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Ulaanbaatar",
    "label": "Asia/Ulaanbaatar (+08 – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Ulan_Bator",
    "label": "Asia/Ulan_Bator (+08 – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Asia/Urumqi",
    "label": "Asia/Urumqi (+06 – no DST)",
    "offset": "+06:00",
    "dstOffset": "+06:00"
  },
  {
    "value": "Asia/Ust-Nera",
    "label": "Asia/Ust-Nera (+10 – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Asia/Vientiane",
    "label": "Asia/Vientiane (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Asia/Vladivostok",
    "label": "Asia/Vladivostok (+10 – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Asia/Yakutsk",
    "label": "Asia/Yakutsk (+09 – no DST)",
    "offset": "+09:00",
    "dstOffset": "+09:00"
  },
  {
    "value": "Asia/Yangon",
    "label": "Asia/Yangon (+0630 – no DST)",
    "offset": "+06:30",
    "dstOffset": "+06:30"
  },
  {
    "value": "Asia/Yekaterinburg",
    "label": "Asia/Yekaterinburg (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Asia/Yerevan",
    "label": "Asia/Yerevan (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Atlantic/Azores",
    "label": "Atlantic/Azores (-01/+00)",
    "offset": "-01:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Atlantic/Bermuda",
    "label": "Atlantic/Bermuda (AST/ADT)",
    "offset": "-04:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "Atlantic/Canary",
    "label": "Atlantic/Canary (WET/WEST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Atlantic/Cape_Verde",
    "label": "Atlantic/Cape_Verde (-01 – no DST)",
    "offset": "-01:00",
    "dstOffset": "-01:00"
  },
  {
    "value": "Atlantic/Faeroe",
    "label": "Atlantic/Faeroe (WET/WEST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Atlantic/Faroe",
    "label": "Atlantic/Faroe (WET/WEST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Atlantic/Jan_Mayen",
    "label": "Atlantic/Jan_Mayen (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Atlantic/Madeira",
    "label": "Atlantic/Madeira (WET/WEST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Atlantic/Reykjavik",
    "label": "Atlantic/Reykjavik (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Atlantic/South_Georgia",
    "label": "Atlantic/South_Georgia (-02 – no DST)",
    "offset": "-02:00",
    "dstOffset": "-02:00"
  },
  {
    "value": "Atlantic/St_Helena",
    "label": "Atlantic/St_Helena (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Atlantic/Stanley",
    "label": "Atlantic/Stanley (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "Australia/ACT",
    "label": "Australia/ACT (AEDT/AEST)",
    "offset": "+11:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Australia/Adelaide",
    "label": "Australia/Adelaide (ACDT/ACST)",
    "offset": "+10:30",
    "dstOffset": "+09:30"
  },
  {
    "value": "Australia/Brisbane",
    "label": "Australia/Brisbane (AEST – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Australia/Broken_Hill",
    "label": "Australia/Broken_Hill (ACDT/ACST)",
    "offset": "+10:30",
    "dstOffset": "+09:30"
  },
  {
    "value": "Australia/Canberra",
    "label": "Australia/Canberra (AEDT/AEST)",
    "offset": "+11:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Australia/Currie",
    "label": "Australia/Currie (AEDT/AEST)",
    "offset": "+11:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Australia/Darwin",
    "label": "Australia/Darwin (ACST – no DST)",
    "offset": "+09:30",
    "dstOffset": "+09:30"
  },
  {
    "value": "Australia/Eucla",
    "label": "Australia/Eucla (+0845 – no DST)",
    "offset": "+08:45",
    "dstOffset": "+08:45"
  },
  {
    "value": "Australia/Hobart",
    "label": "Australia/Hobart (AEDT/AEST)",
    "offset": "+11:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Australia/LHI",
    "label": "Australia/LHI (+11/+1030)",
    "offset": "+11:00",
    "dstOffset": "+10:30"
  },
  {
    "value": "Australia/Lindeman",
    "label": "Australia/Lindeman (AEST – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Australia/Lord_Howe",
    "label": "Australia/Lord_Howe (+11/+1030)",
    "offset": "+11:00",
    "dstOffset": "+10:30"
  },
  {
    "value": "Australia/Melbourne",
    "label": "Australia/Melbourne (AEDT/AEST)",
    "offset": "+11:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Australia/NSW",
    "label": "Australia/NSW (AEDT/AEST)",
    "offset": "+11:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Australia/North",
    "label": "Australia/North (ACST – no DST)",
    "offset": "+09:30",
    "dstOffset": "+09:30"
  },
  {
    "value": "Australia/Perth",
    "label": "Australia/Perth (AWST – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Australia/Queensland",
    "label": "Australia/Queensland (AEST – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Australia/South",
    "label": "Australia/South (ACDT/ACST)",
    "offset": "+10:30",
    "dstOffset": "+09:30"
  },
  {
    "value": "Australia/Sydney",
    "label": "Australia/Sydney (AEDT/AEST)",
    "offset": "+11:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Australia/Tasmania",
    "label": "Australia/Tasmania (AEDT/AEST)",
    "offset": "+11:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Australia/Victoria",
    "label": "Australia/Victoria (AEDT/AEST)",
    "offset": "+11:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Australia/West",
    "label": "Australia/West (AWST – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Australia/Yancowinna",
    "label": "Australia/Yancowinna (ACDT/ACST)",
    "offset": "+10:30",
    "dstOffset": "+09:30"
  },
  {
    "value": "Brazil/Acre",
    "label": "Brazil/Acre (-05 – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "Brazil/DeNoronha",
    "label": "Brazil/DeNoronha (-02 – no DST)",
    "offset": "-02:00",
    "dstOffset": "-02:00"
  },
  {
    "value": "Brazil/East",
    "label": "Brazil/East (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "Brazil/West",
    "label": "Brazil/West (-04 – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "CET",
    "label": "CET (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "CST6CDT",
    "label": "CST6CDT (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "Canada/Atlantic",
    "label": "Canada/Atlantic (AST/ADT)",
    "offset": "-04:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "Canada/Central",
    "label": "Canada/Central (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "Canada/Eastern",
    "label": "Canada/Eastern (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "Canada/Mountain",
    "label": "Canada/Mountain (MST/MDT)",
    "offset": "-07:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "Canada/Newfoundland",
    "label": "Canada/Newfoundland (NST/NDT)",
    "offset": "-03:30",
    "dstOffset": "-02:30"
  },
  {
    "value": "Canada/Pacific",
    "label": "Canada/Pacific (PST/PDT)",
    "offset": "-08:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "Canada/Saskatchewan",
    "label": "Canada/Saskatchewan (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "Canada/Yukon",
    "label": "Canada/Yukon (MST – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "Chile/Continental",
    "label": "Chile/Continental (-03/-04)",
    "offset": "-03:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "Chile/EasterIsland",
    "label": "Chile/EasterIsland (-05/-06)",
    "offset": "-05:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "Cuba",
    "label": "Cuba (CST/CDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "EET",
    "label": "EET (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "EST",
    "label": "EST (EST – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "EST5EDT",
    "label": "EST5EDT (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "Egypt",
    "label": "Egypt (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Eire",
    "label": "Eire (GMT/IST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Etc/GMT",
    "label": "Etc/GMT (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Etc/GMT+0",
    "label": "Etc/GMT+0 (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Etc/GMT+1",
    "label": "Etc/GMT+1 (-01 – no DST)",
    "offset": "-01:00",
    "dstOffset": "-01:00"
  },
  {
    "value": "Etc/GMT+10",
    "label": "Etc/GMT+10 (-10 – no DST)",
    "offset": "-10:00",
    "dstOffset": "-10:00"
  },
  {
    "value": "Etc/GMT+11",
    "label": "Etc/GMT+11 (-11 – no DST)",
    "offset": "-11:00",
    "dstOffset": "-11:00"
  },
  {
    "value": "Etc/GMT+12",
    "label": "Etc/GMT+12 (-12 – no DST)",
    "offset": "-12:00",
    "dstOffset": "-12:00"
  },
  {
    "value": "Etc/GMT+2",
    "label": "Etc/GMT+2 (-02 – no DST)",
    "offset": "-02:00",
    "dstOffset": "-02:00"
  },
  {
    "value": "Etc/GMT+3",
    "label": "Etc/GMT+3 (-03 – no DST)",
    "offset": "-03:00",
    "dstOffset": "-03:00"
  },
  {
    "value": "Etc/GMT+4",
    "label": "Etc/GMT+4 (-04 – no DST)",
    "offset": "-04:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "Etc/GMT+5",
    "label": "Etc/GMT+5 (-05 – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "Etc/GMT+6",
    "label": "Etc/GMT+6 (-06 – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "Etc/GMT+7",
    "label": "Etc/GMT+7 (-07 – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "Etc/GMT+8",
    "label": "Etc/GMT+8 (-08 – no DST)",
    "offset": "-08:00",
    "dstOffset": "-08:00"
  },
  {
    "value": "Etc/GMT+9",
    "label": "Etc/GMT+9 (-09 – no DST)",
    "offset": "-09:00",
    "dstOffset": "-09:00"
  },
  {
    "value": "Etc/GMT-0",
    "label": "Etc/GMT-0 (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Etc/GMT-1",
    "label": "Etc/GMT-1 (+01 – no DST)",
    "offset": "+01:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Etc/GMT-10",
    "label": "Etc/GMT-10 (+10 – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Etc/GMT-11",
    "label": "Etc/GMT-11 (+11 – no DST)",
    "offset": "+11:00",
    "dstOffset": "+11:00"
  },
  {
    "value": "Etc/GMT-12",
    "label": "Etc/GMT-12 (+12 – no DST)",
    "offset": "+12:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Etc/GMT-13",
    "label": "Etc/GMT-13 (+13 – no DST)",
    "offset": "+13:00",
    "dstOffset": "+13:00"
  },
  {
    "value": "Etc/GMT-14",
    "label": "Etc/GMT-14 (+14 – no DST)",
    "offset": "+14:00",
    "dstOffset": "+14:00"
  },
  {
    "value": "Etc/GMT-2",
    "label": "Etc/GMT-2 (+02 – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Etc/GMT-3",
    "label": "Etc/GMT-3 (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Etc/GMT-4",
    "label": "Etc/GMT-4 (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Etc/GMT-5",
    "label": "Etc/GMT-5 (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Etc/GMT-6",
    "label": "Etc/GMT-6 (+06 – no DST)",
    "offset": "+06:00",
    "dstOffset": "+06:00"
  },
  {
    "value": "Etc/GMT-7",
    "label": "Etc/GMT-7 (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Etc/GMT-8",
    "label": "Etc/GMT-8 (+08 – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Etc/GMT-9",
    "label": "Etc/GMT-9 (+09 – no DST)",
    "offset": "+09:00",
    "dstOffset": "+09:00"
  },
  {
    "value": "Etc/GMT0",
    "label": "Etc/GMT0 (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Etc/Greenwich",
    "label": "Etc/Greenwich (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Etc/UCT",
    "label": "Etc/UCT (UTC – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Etc/UTC",
    "label": "Etc/UTC (UTC – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Etc/Universal",
    "label": "Etc/Universal (UTC – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Etc/Zulu",
    "label": "Etc/Zulu (UTC – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Europe/Amsterdam",
    "label": "Europe/Amsterdam (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Andorra",
    "label": "Europe/Andorra (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Astrakhan",
    "label": "Europe/Astrakhan (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Europe/Athens",
    "label": "Europe/Athens (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Belfast",
    "label": "Europe/Belfast (GMT/BST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Europe/Belgrade",
    "label": "Europe/Belgrade (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Berlin",
    "label": "Europe/Berlin (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Bratislava",
    "label": "Europe/Bratislava (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Brussels",
    "label": "Europe/Brussels (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Bucharest",
    "label": "Europe/Bucharest (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Budapest",
    "label": "Europe/Budapest (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Busingen",
    "label": "Europe/Busingen (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Chisinau",
    "label": "Europe/Chisinau (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Copenhagen",
    "label": "Europe/Copenhagen (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Dublin",
    "label": "Europe/Dublin (GMT/IST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Europe/Gibraltar",
    "label": "Europe/Gibraltar (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Guernsey",
    "label": "Europe/Guernsey (GMT/BST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Europe/Helsinki",
    "label": "Europe/Helsinki (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Isle_of_Man",
    "label": "Europe/Isle_of_Man (GMT/BST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Europe/Istanbul",
    "label": "Europe/Istanbul (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Jersey",
    "label": "Europe/Jersey (GMT/BST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Europe/Kaliningrad",
    "label": "Europe/Kaliningrad (EET – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Kiev",
    "label": "Europe/Kiev (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Kirov",
    "label": "Europe/Kirov (MSK – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Kyiv",
    "label": "Europe/Kyiv (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Lisbon",
    "label": "Europe/Lisbon (WET/WEST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Europe/Ljubljana",
    "label": "Europe/Ljubljana (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/London",
    "label": "Europe/London (GMT/BST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Europe/Luxembourg",
    "label": "Europe/Luxembourg (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Madrid",
    "label": "Europe/Madrid (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Malta",
    "label": "Europe/Malta (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Mariehamn",
    "label": "Europe/Mariehamn (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Minsk",
    "label": "Europe/Minsk (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Monaco",
    "label": "Europe/Monaco (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Moscow",
    "label": "Europe/Moscow (MSK – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Nicosia",
    "label": "Europe/Nicosia (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Oslo",
    "label": "Europe/Oslo (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Paris",
    "label": "Europe/Paris (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Podgorica",
    "label": "Europe/Podgorica (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Prague",
    "label": "Europe/Prague (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Riga",
    "label": "Europe/Riga (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Rome",
    "label": "Europe/Rome (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Samara",
    "label": "Europe/Samara (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Europe/San_Marino",
    "label": "Europe/San_Marino (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Sarajevo",
    "label": "Europe/Sarajevo (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Saratov",
    "label": "Europe/Saratov (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Europe/Simferopol",
    "label": "Europe/Simferopol (MSK – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Skopje",
    "label": "Europe/Skopje (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Sofia",
    "label": "Europe/Sofia (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Stockholm",
    "label": "Europe/Stockholm (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Tallinn",
    "label": "Europe/Tallinn (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Tirane",
    "label": "Europe/Tirane (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Tiraspol",
    "label": "Europe/Tiraspol (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Ulyanovsk",
    "label": "Europe/Ulyanovsk (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Europe/Uzhgorod",
    "label": "Europe/Uzhgorod (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Vaduz",
    "label": "Europe/Vaduz (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Vatican",
    "label": "Europe/Vatican (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Vienna",
    "label": "Europe/Vienna (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Vilnius",
    "label": "Europe/Vilnius (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Volgograd",
    "label": "Europe/Volgograd (MSK – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Warsaw",
    "label": "Europe/Warsaw (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Zagreb",
    "label": "Europe/Zagreb (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Europe/Zaporozhye",
    "label": "Europe/Zaporozhye (EET/EEST)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Europe/Zurich",
    "label": "Europe/Zurich (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "GB",
    "label": "GB (GMT/BST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "GB-Eire",
    "label": "GB-Eire (GMT/BST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "GMT",
    "label": "GMT (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "GMT+0",
    "label": "GMT+0 (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "GMT-0",
    "label": "GMT-0 (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "GMT0",
    "label": "GMT0 (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Greenwich",
    "label": "Greenwich (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "HST",
    "label": "HST (HST – no DST)",
    "offset": "-10:00",
    "dstOffset": "-10:00"
  },
  {
    "value": "Hongkong",
    "label": "Hongkong (HKT – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Iceland",
    "label": "Iceland (GMT – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Indian/Antananarivo",
    "label": "Indian/Antananarivo (EAT – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Indian/Chagos",
    "label": "Indian/Chagos (+06 – no DST)",
    "offset": "+06:00",
    "dstOffset": "+06:00"
  },
  {
    "value": "Indian/Christmas",
    "label": "Indian/Christmas (+07 – no DST)",
    "offset": "+07:00",
    "dstOffset": "+07:00"
  },
  {
    "value": "Indian/Cocos",
    "label": "Indian/Cocos (+0630 – no DST)",
    "offset": "+06:30",
    "dstOffset": "+06:30"
  },
  {
    "value": "Indian/Comoro",
    "label": "Indian/Comoro (EAT – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Indian/Kerguelen",
    "label": "Indian/Kerguelen (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Indian/Mahe",
    "label": "Indian/Mahe (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Indian/Maldives",
    "label": "Indian/Maldives (+05 – no DST)",
    "offset": "+05:00",
    "dstOffset": "+05:00"
  },
  {
    "value": "Indian/Mauritius",
    "label": "Indian/Mauritius (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Indian/Mayotte",
    "label": "Indian/Mayotte (EAT – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Indian/Reunion",
    "label": "Indian/Reunion (+04 – no DST)",
    "offset": "+04:00",
    "dstOffset": "+04:00"
  },
  {
    "value": "Iran",
    "label": "Iran (+0330 – no DST)",
    "offset": "+03:30",
    "dstOffset": "+03:30"
  },
  {
    "value": "Israel",
    "label": "Israel (IST/IDT)",
    "offset": "+02:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "Jamaica",
    "label": "Jamaica (EST – no DST)",
    "offset": "-05:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "Japan",
    "label": "Japan (JST – no DST)",
    "offset": "+09:00",
    "dstOffset": "+09:00"
  },
  {
    "value": "Kwajalein",
    "label": "Kwajalein (+12 – no DST)",
    "offset": "+12:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Libya",
    "label": "Libya (EET – no DST)",
    "offset": "+02:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "MET",
    "label": "MET (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "MST",
    "label": "MST (MST – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "MST7MDT",
    "label": "MST7MDT (MST/MDT)",
    "offset": "-07:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "Mexico/BajaNorte",
    "label": "Mexico/BajaNorte (PST/PDT)",
    "offset": "-08:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "Mexico/BajaSur",
    "label": "Mexico/BajaSur (MST – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "Mexico/General",
    "label": "Mexico/General (CST – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "NZ",
    "label": "NZ (NZDT/NZST)",
    "offset": "+13:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "NZ-CHAT",
    "label": "NZ-CHAT (+1345/+1245)",
    "offset": "+13:45",
    "dstOffset": "+12:45"
  },
  {
    "value": "Navajo",
    "label": "Navajo (MST/MDT)",
    "offset": "-07:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "PRC",
    "label": "PRC (CST – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "PST8PDT",
    "label": "PST8PDT (PST/PDT)",
    "offset": "-08:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "Pacific/Apia",
    "label": "Pacific/Apia (+13 – no DST)",
    "offset": "+13:00",
    "dstOffset": "+13:00"
  },
  {
    "value": "Pacific/Auckland",
    "label": "Pacific/Auckland (NZDT/NZST)",
    "offset": "+13:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Pacific/Bougainville",
    "label": "Pacific/Bougainville (+11 – no DST)",
    "offset": "+11:00",
    "dstOffset": "+11:00"
  },
  {
    "value": "Pacific/Chatham",
    "label": "Pacific/Chatham (+1345/+1245)",
    "offset": "+13:45",
    "dstOffset": "+12:45"
  },
  {
    "value": "Pacific/Chuuk",
    "label": "Pacific/Chuuk (+10 – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Pacific/Easter",
    "label": "Pacific/Easter (-05/-06)",
    "offset": "-05:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "Pacific/Efate",
    "label": "Pacific/Efate (+11 – no DST)",
    "offset": "+11:00",
    "dstOffset": "+11:00"
  },
  {
    "value": "Pacific/Enderbury",
    "label": "Pacific/Enderbury (+13 – no DST)",
    "offset": "+13:00",
    "dstOffset": "+13:00"
  },
  {
    "value": "Pacific/Fakaofo",
    "label": "Pacific/Fakaofo (+13 – no DST)",
    "offset": "+13:00",
    "dstOffset": "+13:00"
  },
  {
    "value": "Pacific/Fiji",
    "label": "Pacific/Fiji (+12 – no DST)",
    "offset": "+12:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Pacific/Funafuti",
    "label": "Pacific/Funafuti (+12 – no DST)",
    "offset": "+12:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Pacific/Galapagos",
    "label": "Pacific/Galapagos (-06 – no DST)",
    "offset": "-06:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "Pacific/Gambier",
    "label": "Pacific/Gambier (-09 – no DST)",
    "offset": "-09:00",
    "dstOffset": "-09:00"
  },
  {
    "value": "Pacific/Guadalcanal",
    "label": "Pacific/Guadalcanal (+11 – no DST)",
    "offset": "+11:00",
    "dstOffset": "+11:00"
  },
  {
    "value": "Pacific/Guam",
    "label": "Pacific/Guam (ChST – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Pacific/Honolulu",
    "label": "Pacific/Honolulu (HST – no DST)",
    "offset": "-10:00",
    "dstOffset": "-10:00"
  },
  {
    "value": "Pacific/Johnston",
    "label": "Pacific/Johnston (HST – no DST)",
    "offset": "-10:00",
    "dstOffset": "-10:00"
  },
  {
    "value": "Pacific/Kanton",
    "label": "Pacific/Kanton (+13 – no DST)",
    "offset": "+13:00",
    "dstOffset": "+13:00"
  },
  {
    "value": "Pacific/Kiritimati",
    "label": "Pacific/Kiritimati (+14 – no DST)",
    "offset": "+14:00",
    "dstOffset": "+14:00"
  },
  {
    "value": "Pacific/Kosrae",
    "label": "Pacific/Kosrae (+11 – no DST)",
    "offset": "+11:00",
    "dstOffset": "+11:00"
  },
  {
    "value": "Pacific/Kwajalein",
    "label": "Pacific/Kwajalein (+12 – no DST)",
    "offset": "+12:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Pacific/Majuro",
    "label": "Pacific/Majuro (+12 – no DST)",
    "offset": "+12:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Pacific/Marquesas",
    "label": "Pacific/Marquesas (-0930 – no DST)",
    "offset": "-09:30",
    "dstOffset": "-09:30"
  },
  {
    "value": "Pacific/Midway",
    "label": "Pacific/Midway (SST – no DST)",
    "offset": "-11:00",
    "dstOffset": "-11:00"
  },
  {
    "value": "Pacific/Nauru",
    "label": "Pacific/Nauru (+12 – no DST)",
    "offset": "+12:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Pacific/Niue",
    "label": "Pacific/Niue (-11 – no DST)",
    "offset": "-11:00",
    "dstOffset": "-11:00"
  },
  {
    "value": "Pacific/Norfolk",
    "label": "Pacific/Norfolk (+12/+11)",
    "offset": "+12:00",
    "dstOffset": "+11:00"
  },
  {
    "value": "Pacific/Noumea",
    "label": "Pacific/Noumea (+11 – no DST)",
    "offset": "+11:00",
    "dstOffset": "+11:00"
  },
  {
    "value": "Pacific/Pago_Pago",
    "label": "Pacific/Pago_Pago (SST – no DST)",
    "offset": "-11:00",
    "dstOffset": "-11:00"
  },
  {
    "value": "Pacific/Palau",
    "label": "Pacific/Palau (+09 – no DST)",
    "offset": "+09:00",
    "dstOffset": "+09:00"
  },
  {
    "value": "Pacific/Pitcairn",
    "label": "Pacific/Pitcairn (-08 – no DST)",
    "offset": "-08:00",
    "dstOffset": "-08:00"
  },
  {
    "value": "Pacific/Pohnpei",
    "label": "Pacific/Pohnpei (+11 – no DST)",
    "offset": "+11:00",
    "dstOffset": "+11:00"
  },
  {
    "value": "Pacific/Ponape",
    "label": "Pacific/Ponape (+11 – no DST)",
    "offset": "+11:00",
    "dstOffset": "+11:00"
  },
  {
    "value": "Pacific/Port_Moresby",
    "label": "Pacific/Port_Moresby (+10 – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Pacific/Rarotonga",
    "label": "Pacific/Rarotonga (-10 – no DST)",
    "offset": "-10:00",
    "dstOffset": "-10:00"
  },
  {
    "value": "Pacific/Saipan",
    "label": "Pacific/Saipan (ChST – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Pacific/Samoa",
    "label": "Pacific/Samoa (SST – no DST)",
    "offset": "-11:00",
    "dstOffset": "-11:00"
  },
  {
    "value": "Pacific/Tahiti",
    "label": "Pacific/Tahiti (-10 – no DST)",
    "offset": "-10:00",
    "dstOffset": "-10:00"
  },
  {
    "value": "Pacific/Tarawa",
    "label": "Pacific/Tarawa (+12 – no DST)",
    "offset": "+12:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Pacific/Tongatapu",
    "label": "Pacific/Tongatapu (+13 – no DST)",
    "offset": "+13:00",
    "dstOffset": "+13:00"
  },
  {
    "value": "Pacific/Truk",
    "label": "Pacific/Truk (+10 – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Pacific/Wake",
    "label": "Pacific/Wake (+12 – no DST)",
    "offset": "+12:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Pacific/Wallis",
    "label": "Pacific/Wallis (+12 – no DST)",
    "offset": "+12:00",
    "dstOffset": "+12:00"
  },
  {
    "value": "Pacific/Yap",
    "label": "Pacific/Yap (+10 – no DST)",
    "offset": "+10:00",
    "dstOffset": "+10:00"
  },
  {
    "value": "Poland",
    "label": "Poland (CET/CEST)",
    "offset": "+01:00",
    "dstOffset": "+02:00"
  },
  {
    "value": "Portugal",
    "label": "Portugal (WET/WEST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "ROC",
    "label": "ROC (CST – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "ROK",
    "label": "ROK (KST – no DST)",
    "offset": "+09:00",
    "dstOffset": "+09:00"
  },
  {
    "value": "Singapore",
    "label": "Singapore (+08 – no DST)",
    "offset": "+08:00",
    "dstOffset": "+08:00"
  },
  {
    "value": "Turkey",
    "label": "Turkey (+03 – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "UCT",
    "label": "UCT (UTC – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "US/Alaska",
    "label": "US/Alaska (AKST/AKDT)",
    "offset": "-09:00",
    "dstOffset": "-08:00"
  },
  {
    "value": "US/Aleutian",
    "label": "US/Aleutian (HST/HDT)",
    "offset": "-10:00",
    "dstOffset": "-09:00"
  },
  {
    "value": "US/Arizona",
    "label": "US/Arizona (MST – no DST)",
    "offset": "-07:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "US/Central",
    "label": "US/Central (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "US/East-Indiana",
    "label": "US/East-Indiana (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "US/Eastern",
    "label": "US/Eastern (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "US/Hawaii",
    "label": "US/Hawaii (HST – no DST)",
    "offset": "-10:00",
    "dstOffset": "-10:00"
  },
  {
    "value": "US/Indiana-Starke",
    "label": "US/Indiana-Starke (CST/CDT)",
    "offset": "-06:00",
    "dstOffset": "-05:00"
  },
  {
    "value": "US/Michigan",
    "label": "US/Michigan (EST/EDT)",
    "offset": "-05:00",
    "dstOffset": "-04:00"
  },
  {
    "value": "US/Mountain",
    "label": "US/Mountain (MST/MDT)",
    "offset": "-07:00",
    "dstOffset": "-06:00"
  },
  {
    "value": "US/Pacific",
    "label": "US/Pacific (PST/PDT)",
    "offset": "-08:00",
    "dstOffset": "-07:00"
  },
  {
    "value": "US/Samoa",
    "label": "US/Samoa (SST – no DST)",
    "offset": "-11:00",
    "dstOffset": "-11:00"
  },
  {
    "value": "UTC",
    "label": "UTC (UTC – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "Universal",
    "label": "Universal (UTC – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  },
  {
    "value": "W-SU",
    "label": "W-SU (MSK – no DST)",
    "offset": "+03:00",
    "dstOffset": "+03:00"
  },
  {
    "value": "WET",
    "label": "WET (WET/WEST)",
    "offset": "+00:00",
    "dstOffset": "+01:00"
  },
  {
    "value": "Zulu",
    "label": "Zulu (UTC – no DST)",
    "offset": "+00:00",
    "dstOffset": "+00:00"
  }
];
